import { adminAccess, type AdminAccess } from '@wapharma/domain';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

type SurfaceKey = {
  [K in keyof AdminAccess]: AdminAccess[K] extends boolean ? K : never;
}[keyof AdminAccess];

type RequireSurfaceProps = {
  surface: SurfaceKey;
};

/** Gate a route by pack/grant-derived admin surface. Silent redirect (no toast). */
export function RequireSurface({ surface }: RequireSurfaceProps) {
  const { user } = useAuth();

  const allowed = Boolean(
    user && adminAccess(user.packs, user.roles, user.grants)[surface],
  );

  if (!user) return null;
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
